import _default from './Popup';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Popup/index.js
// module id = 2865
// module chunks = 0